import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { logoutUser } from "../slices/auth/login/thunk";
import Cookies from "js-cookie";

const AuthProtected = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const token = Cookies.get("authToken");
  const authUser = Cookies.get("authUser");

  useEffect(() => {
    if (token && authUser) {
      setAuthorization(token);
    } else {
      dispatch(logoutUser());
    }
  }, [token, authUser, dispatch]);

  if (!token || !authUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export { AuthProtected };
